import type {
  DayOfWeekLayoutQueryVariables,
  DayOfWeekListQueryVariables,
} from '../../graphql/generated/types';

/**
 * Tab 도메인 Query Key 관리
 */
export const TAB_QUERY_KEY_MAP = {
  /**
   * 요일연재 Layout 조회
   * Origin: useDayOfWeekLayoutQuery.getKey
   */
  dayOfWeekLayout: (variables?: DayOfWeekLayoutQueryVariables) =>
    variables === undefined
      ? ['dayOfWeekLayout']
      : ['dayOfWeekLayout', variables],
  /**
   * 요일연재 List 조회
   * Origin: useDayOfWeekListQuery.getKey
   */
  dayOfWeekList: (variables: DayOfWeekListQueryVariables) => [
    'dayOfWeekList',
    variables,
  ],
  /**
   * 요일연재 List 조회 (Infinite)
   * Origin: useInfiniteDayOfWeekListQuery.getKey
   */
  infiniteDayOfWeekList: (variables: DayOfWeekListQueryVariables) => [
    'dayOfWeekList.infinite',
    variables,
  ],
} as const;

/**
 * Tab 도메인 Mutation Key 관리
 */
export const TAB_MUTATION_KEY_MAP = {} as const;
